import { render, staticRenderFns } from "./edit_settings.vue?vue&type=template&id=8f8be206&scoped=true&"
import script from "./edit_settings.vue?vue&type=script&lang=js&"
export * from "./edit_settings.vue?vue&type=script&lang=js&"
import style0 from "./edit_settings.vue?vue&type=style&index=0&id=8f8be206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8be206",
  null
  
)

export default component.exports